<template>
  <div class="account-info">
    <h2 class="title">私人信息</h2>
    <el-form label-position="right"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="85px">
      <el-form-item label="注册时间：">
        {{account.registerTime? account.registerTime : '无'}}
      </el-form-item>
      <el-form-item prop="studentGrade" label="年级">
        <el-input v-model.trim="form.studentGrade" placeholder="请输入年级" />
      </el-form-item>
      <el-form-item prop="studentClass" label="班级">
        <el-input v-model.trim="form.studentClass" placeholder="请输入班级" />
      </el-form-item>
      <el-form-item prop="studentName" label="真实姓名">
        <el-input v-model.trim="form.studentName" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="form.sex">
          <el-radio :label="1">男生</el-radio>
          <el-radio :label="2">女生</el-radio>
          <el-radio :label="0">保密</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="年龄">
        <el-input v-model.number="form.age"
          type="text"
          maxlength="3"
          placeholder="请输入年龄"/>
      </el-form-item>
      <el-form-item prop="region" label="地址">
        <el-input v-model="form.region" placeholder="请输入地址"></el-input>
        <!-- <el-cascader v-model="form.region" :options="citySelectorOptions"></el-cascader> -->
      </el-form-item>
      <h2 class="title">联系方式</h2>
      <el-form-item label="邮箱地址">
        <el-input v-model.trim="form.email" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="QQ号码">
        <el-input v-model.trim="form.qq" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="微信号码">
        <el-input v-model.trim="form.wechat" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item prop="studentPhone" label="电话号码">
        <el-input
          v-model.trim="form.studentPhone"
          :value="account.phone"
          maxlength="11"
          placeholder="请输入电话号码"></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button
        @click="submitForm()"
        style="min-width: 200px;"
        type="primary">保存
      </el-button>
    </el-row>
  </div>
</template>

<script>
import {
  Button,
  // Cascader,
  Form,
  FormItem,
  Input,
  Radio,
  Row,
  RadioGroup,
} from 'element-ui';
// import CHINA_CITY_DATA from '@/services/china';
import api from '@/api/graphql/account';
import utils from '@/services/utils';

export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
    // ElCascader: Cascader,
    ElRow: Row,
  },
  data() {
    return {
      account: {},
      form: {
        studentGrade: '',
        studentClass: '',
        studentName: '',
        studentPhone: '',
        sex: '',
        age: '',
        region: '',
        email: '',
        qq: '',
        wechat: '',
      },
      rules: {
        studentGrade: [
          {
            required: true,
            message: '请输入年级',
            trigger: 'blur',
          },
          {
            max: 6,
            message: '长度在6个字符以内',
            trigger: 'blur',
          },
        ],
        studentClass: [
          {
            required: true,
            message: '请输入班级',
            trigger: 'blur',
          },
          {
            max: 6,
            message: '长度在6个字符以内',
            trigger: 'blur',
          },
        ],
        studentName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
          {
            max: 15,
            message: '长度在15个字符以内',
            trigger: 'blur',
          },
        ],
        region: [
          {
            required: true,
            message: '请输入地址',
            trigger: 'blur',
          },
          {
            max: 50,
            message: '长度在50个字符以内',
            trigger: 'blur',
          },
        ],
        studentPhone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
          {
            max: 11,
            min: 11,
            message: '请输入正确手机号',
            trigger: 'blur',
          },
        ],
      },
      // citySelectorOptions: CHINA_CITY_DATA,
    };
  },
  computed: {},
  methods: {
    getUserInfo() {
      // api.getAccount().then((data) => {
      //   this.account = data.account;
      //   this.form.studentGrade = data.account.studentGrade;
      //   this.form.studentClass = data.account.studentClass;
      //   this.form.studentName = data.account.name;
      //   this.form.studentPhone = data.account.phone;
      //   this.form.sex = data.account.sex;
      //   this.form.age = data.account.age;
      //   this.form.region = data.account.region;
      //   this.form.email = data.account.email;
      //   this.form.qq = data.account.qq;
      //   this.form.wechat = data.account.wechat;
      //   if (this.form.age === 0) {
      //     this.form.age = '';
      //   }
      // });
    },
    submitForm() {
      this.$refs.form.validate((result) => {
        if (result) {
          if (this.form.age === '') {
            this.form.age = 0;
          }
          api.updatedAccount(this.form).then((data) => {
            if (this.form.age === 0) {
              this.form.age = '';
            }
            if (data.updateAccount) {
              utils.alert('保存成功');
            } else {
              utils.alert('保存失败');
            }
          });
        }
      });
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .account-info {
    box-sizing: border-box;
    width: $content-width-medium;
    min-height: 200px;
    padding: 20px;
    .title {
      text-align: center;
    }
    .el-form {
      overflow: hidden;
      margin-bottom: 40px;
      margin-top: 20px;
      .el-form-item {
        max-width: 360px;
        margin: 0 auto 20px;
        .el-cascader {
          width: 280px;
        }
      }
    }
  }
  input[type=number] {
    -moz-appearance:textfield;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
